module.exports = __webpack_public_path__ + "static/media/coing.848a71eb.png";